import "./Plans.css"
import {plansData} from "../../data/plansData"
import tick from "../../assets/whiteTick.png"
import React from 'react'

const Plans = () => {
  return (
    <div className="plans-container" id="OurPrograms">
        <div className="programs-header" style={{gap:'2rem'}}>
            <span className="stroke-text">READY TO START</span>
            <span>YOUR JOURNEY</span>
            <span className="stroke-text">NOW WITHUS</span>
        </div>
        <div className="plans">
            {plansData.map((plan,i) =>(
                <div className="plan" key={i}>
                    {plan.icon}
                    <span>{plan.name}</span>
                    <span>$ {plan.price}</span>

                    <div className="features">
                        {plan.features.map((feature,i)=>(
                            <div className="feature">
                                <img src={tick} alt="" />
                                <span key={i}>
                                    {feature}
                                </span>
                            </div>
                        ))}
                    </div>
                    <div><span>See more benegits -></span></div>
                    <button className="btn">Join Now</button>
                </div>
            ))}
        </div>
    </div>
  )
}

export default Plans